import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ReactComponent as Refresh } from '@mike/mike-shared-frontend/media/icons/Refresh'
import { ButtonProps as MuiButtonProps } from '@mui/material/Button'
import messages from '../../shared/messages'
import { iconSecondaryStyle, StyledIconButton } from './iconStyles'

const RefreshButton = (buttonProps: MuiButtonProps) => {
  return (
    <StyledIconButton {...buttonProps}>
      <Refresh className={iconSecondaryStyle(buttonProps.disabled)} />
      <FormattedMessage id={messages.refresh.id} />
    </StyledIconButton>
  )
}

export default RefreshButton
